/**
 * Hemline interaction layer.
 * Mobile menu + cart drawer + search drawer.
 * Open via [data-{name}-open], close via [data-{name}-close], Escape closes all.
 */
(function () {
  function getMenu() { return document.getElementById('mobile-menu'); }
  function getCartDrawer() { return document.getElementById('cart-drawer'); }
  function getSearchDrawer() { return document.getElementById('search-drawer'); }

  function lockScroll() { /* no-op */ }
  function unlockScroll() { /* no-op */ }
  function syncBodyClass() {
    var cd = getCartDrawer();
    if (cd && cd.classList.contains('open')) {
      document.body.classList.add('cart-drawer-open');
    } else {
      document.body.classList.remove('cart-drawer-open');
    }
  }

  function openEl(el) {
    if (!el) return;
    el.classList.add('open');
    el.setAttribute('aria-hidden', 'false');
    syncBodyClass();
  }
  function closeEl(el) {
    if (!el) return;
    el.classList.remove('open');
    el.setAttribute('aria-hidden', 'true');
    syncBodyClass();
  }
  function isAnyOverlayOpen() {
    var menu = getMenu(), cd = getCartDrawer(), sd = getSearchDrawer();
    var modal = document.getElementById('hl-quick-add');
    return (menu && menu.classList.contains('open')) ||
           (cd && cd.classList.contains('open')) ||
           (sd && sd.classList.contains('open')) ||
           (modal && modal.classList.contains('is-open'));
  }
  function closeAll() {
    [getMenu(), getCartDrawer(), getSearchDrawer()].forEach(closeEl);
    unlockScroll();
  }

  // Document-level delegation so triggers keep working after section swaps.
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-mm-open]'))    { e.preventDefault(); openEl(getMenu()); return; }
    if (e.target.closest('[data-mm-close]'))   { e.preventDefault(); closeEl(getMenu()); return; }
    if (e.target.closest('[data-cart-open]'))  { e.preventDefault(); openEl(getCartDrawer()); return; }
    if (e.target.closest('[data-cart-close]')) { e.preventDefault(); closeEl(getCartDrawer()); return; }
    if (e.target.closest('[data-search-open]')) { e.preventDefault(); openEl(getSearchDrawer()); return; }
    if (e.target.closest('[data-search-close]')){ e.preventDefault(); closeEl(getSearchDrawer()); return; }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll();
  });

  // Apply pre-rendered sections to the DOM (no extra HTTP roundtrip).
  function applySections(sections) {
    if (!sections) return;
    var wasCartOpen = (function () { var d = getCartDrawer(); return d && d.classList.contains('open'); })();
    Object.keys(sections).forEach(function (name) {
      var html = sections[name];
      if (!html) return;
      var oldEl = document.getElementById('shopify-section-' + name);
      if (!oldEl) return;
      var temp = document.createElement('div');
      temp.innerHTML = html.trim();
      var newEl = temp.firstElementChild;
      if (newEl) oldEl.replaceWith(newEl);
    });
    if (wasCartOpen) {
      var d = getCartDrawer();
      if (d) { d.classList.add('open'); d.setAttribute('aria-hidden', 'false'); lockScroll(); }
    }
  }
  // Fallback when a cart endpoint didn't return sections.
  function refreshCartSections() {
    return fetch('/?sections=cart-drawer,header', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(applySections)
      .catch(function () {});
  }
  window.__hlRefreshCartSections = refreshCartSections;
  window.__hlApplySections = applySections;

  // AJAX cart line operations — fully optimistic. All UI updates happen
  // synchronously on click; the server call is debounced 350ms behind so
  // rapid clicks coalesce into a single request.
  var pendingChanges = Object.create(null); // { lineKey: latestQty }
  var syncTimer = null;
  function scheduleSync() {
    if (syncTimer) clearTimeout(syncTimer);
    syncTimer = setTimeout(flushChanges, 350);
  }
  function flushChanges() {
    syncTimer = null;
    var keys = Object.keys(pendingChanges);
    if (keys.length === 0) return;
    keys.forEach(function (key) {
      var qty = pendingChanges[key];
      delete pendingChanges[key];
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty }),
        credentials: 'same-origin'
      }).catch(function () {});
    });
  }

  // ---- Optimistic UI helpers ----
  // Format money using the cart's current currency. The body carries
  // data-cart-currency (ISO code, e.g. "USD", "EUR", "JPY") and a locale
  // hint so prices read correctly regardless of which Market the user is in.
  function moneyFormat(cents) {
    var body = document.body || {};
    var currency = (body.dataset && body.dataset.cartCurrency) || 'USD';
    var locale = (body.dataset && body.dataset.locale) || (navigator.language || 'en-US');
    var amount = cents / 100;
    try {
      var minimumFractionDigits = (cents % 100 === 0) ? 0 : 2;
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: minimumFractionDigits,
        maximumFractionDigits: 2
      }).format(amount);
    } catch (e) {
      // Fallback if Intl or the currency code isn't supported
      var symbol = (body.dataset && body.dataset.cartCurrencySymbol) || '$';
      return symbol + (cents % 100 === 0 ? amount : amount.toFixed(2));
    }
  }
  function recalcLine(lineEl) {
    if (!lineEl) return;
    var unit = parseInt(lineEl.dataset.unitPrice, 10) || 0;
    var input = lineEl.querySelector('[data-line-quantity]');
    var qty = input ? parseInt(input.value, 10) || 0 : 0;
    var priceDisp = lineEl.querySelector('[data-line-price-display]');
    if (priceDisp) priceDisp.textContent = moneyFormat(unit * qty);
  }
  function recalcSubtotal() {
    var subtotal = 0;
    // Iterate any element marked as a cart line — works for both the drawer
    // (.hl-cd__item) and the cart page (.hl-cart-item).
    document.querySelectorAll('[data-line-key][data-unit-price]').forEach(function (line) {
      var unit = parseInt(line.dataset.unitPrice, 10) || 0;
      var input = line.querySelector('[data-line-quantity]');
      var qty = input ? parseInt(input.value, 10) || 0 : 0;
      subtotal += unit * qty;
    });
    var formatted = moneyFormat(subtotal);
    document.querySelectorAll('[data-cart-subtotal-display]').forEach(function (el) { el.textContent = formatted; });
    document.querySelectorAll('[data-cart-total-display]').forEach(function (el) { el.textContent = formatted; });
  }
  function recalcCount() {
    var total = 0;
    document.querySelectorAll('[data-line-key][data-unit-price] [data-line-quantity]').forEach(function (input) {
      total += parseInt(input.value, 10) || 0;
    });
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = total;
    });
  }
  function currentCartTotalCents() {
    var subtotal = 0;
    document.querySelectorAll('[data-line-key][data-unit-price]').forEach(function (line) {
      var unit = parseInt(line.dataset.unitPrice, 10) || 0;
      var input = line.querySelector('[data-line-quantity]');
      var qty = input ? parseInt(input.value, 10) || 0 : 0;
      subtotal += unit * qty;
    });
    return subtotal;
  }
  function recalcShipping() {
    document.querySelectorAll('[data-shipping-bar]').forEach(function (bar) {
      var threshold = parseInt(bar.dataset.threshold, 10) || 0;
      if (threshold <= 0) return;
      var subtotal = currentCartTotalCents();
      var msgEl = bar.querySelector('[data-shipping-message]');
      var fillEl = bar.querySelector('[data-shipping-progress-fill]');
      var unlockedText = bar.dataset.unlockedText || 'Free shipping unlocked.';
      var belowText = bar.dataset.belowText || 'away from free shipping';
      if (subtotal >= threshold) {
        if (msgEl && !msgEl.dataset.unlocked) {
          // Swap to unlocked layout (preserve the icon if there was one)
          var icon = msgEl.querySelector('i');
          msgEl.innerHTML = (icon ? icon.outerHTML : '') + '<span><span style="font-weight:500;">' + unlockedText + '</span></span>';
          msgEl.dataset.unlocked = '1';
          msgEl.classList.add('hl-cd__shipbar--unlocked');
        }
        if (fillEl) fillEl.style.width = '100%';
      } else {
        if (msgEl) {
          var remaining = threshold - subtotal;
          var remainingFormatted = moneyFormat(remaining);
          // If currently unlocked, swap back to "X away" layout
          if (msgEl.dataset.unlocked) {
            var icon = msgEl.querySelector('i');
            msgEl.innerHTML = (icon ? icon.outerHTML : '') +
              '<span><span style="font-weight:500;" data-shipping-remaining>' + remainingFormatted + '</span> ' + belowText + '</span>';
            delete msgEl.dataset.unlocked;
            msgEl.classList.remove('hl-cd__shipbar--unlocked');
          } else {
            var remainEl = msgEl.querySelector('[data-shipping-remaining]');
            if (remainEl) remainEl.textContent = remainingFormatted;
          }
        }
        if (fillEl) {
          var pct = Math.min(100, (subtotal / threshold) * 100);
          fillEl.style.width = pct + '%';
        }
      }
    });
  }
  function setQty(lineEl, qty) {
    if (!lineEl) return;
    var key = lineEl.dataset.lineKey;
    var input = lineEl.querySelector('[data-line-quantity]');
    qty = Math.max(0, qty);
    if (input) input.value = qty;
    if (qty === 0) {
      // Collapse the line visually
      lineEl.style.transition = 'opacity 200ms ease, max-height 250ms ease, padding 250ms ease, margin 250ms ease';
      lineEl.style.opacity = '0';
      lineEl.style.maxHeight = lineEl.offsetHeight + 'px';
      requestAnimationFrame(function () {
        lineEl.style.maxHeight = '0';
        lineEl.style.padding = '0';
        lineEl.style.margin = '0';
      });
      setTimeout(function () { lineEl.remove(); recalcSubtotal(); recalcCount(); recalcShipping(); }, 250);
    } else {
      recalcLine(lineEl);
    }
    recalcSubtotal();
    recalcCount();
    recalcShipping();
    pendingChanges[key] = qty;
    scheduleSync();
  }

  document.addEventListener('click', function (e) {
    var removeBtn = e.target.closest('[data-cart-remove]');
    if (removeBtn) {
      e.preventDefault();
      e.stopPropagation();
      var lineEl = removeBtn.closest('[data-line-key]');
      setQty(lineEl, 0);
      return;
    }
    var inc = e.target.closest('[data-cart-qty-increment]');
    var dec = e.target.closest('[data-cart-qty-decrement]');
    var stepper = inc || dec;
    if (!stepper) return;
    e.preventDefault();
    e.stopPropagation();
    var lineEl = stepper.closest('[data-line-key]');
    if (!lineEl) return;
    var input = lineEl.querySelector('[data-line-quantity]');
    var current = input ? parseInt(input.value, 10) || 0 : 0;
    setQty(lineEl, inc ? current + 1 : current - 1);
  });

  // Allow typing a custom number directly into the qty input.
  document.addEventListener('input', function (e) {
    var input = e.target.closest('[data-line-quantity]');
    if (!input) return;
    var lineEl = input.closest('[data-line-key]');
    if (!lineEl) return;
    var qty = parseInt(input.value, 10);
    if (isNaN(qty) || qty < 0) return; // wait until they finish typing a valid number
    if (qty === 0) { setQty(lineEl, 0); return; }
    var key = lineEl.dataset.lineKey;
    recalcLine(lineEl);
    recalcSubtotal();
    recalcCount();
    recalcShipping();
    pendingChanges[key] = qty;
    scheduleSync();
  });

  // Flush any pending qty changes when the drawer closes (or page unloads)
  // so we don't lose updates that were sitting in the debounce window.
  window.addEventListener('beforeunload', function () { if (syncTimer) flushChanges(); });
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-close]') && syncTimer) flushChanges();
  });

  // Cart note: persist on blur via /cart/update.js
  document.addEventListener('change', function (e) {
    var note = e.target.closest('[data-cart-note]');
    if (!note) return;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ note: note.value }),
      credentials: 'same-origin'
    });
  });

  // Mobile drawer locale: auto-submit the localization form on country/language change.
  document.querySelectorAll('[data-mm-locale]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var form = sel.closest('form');
      if (form) form.submit();
    });
  });

  // Quick add: fetch product JSON, open modal, render variant pickers,
  // submit to /cart/add.js, then refresh the cart drawer state.
  (function () {
    var modal = document.getElementById('hl-quick-add');
    if (!modal) return;
    var body = modal.querySelector('[data-quick-add-body]');
    var current = null; // current product object

    // Multi-currency formatter. Prefers Intl.NumberFormat with the cart's
    // currency (set on <body data-cart-currency>); falls back to a plain
    // dollar sign only if the API or locale isn't available.
    function moneyFormat(cents) {
      var currency = (document.body.dataset && document.body.dataset.cartCurrency) || 'USD';
      var locale = (document.body.dataset && document.body.dataset.locale) || undefined;
      try {
        return new Intl.NumberFormat(locale, { style: 'currency', currency: currency }).format(cents / 100);
      } catch (e) {
        var n = (cents / 100).toFixed(2).replace(/\.00$/, '');
        return '$' + n;
      }
    }

    function open() {
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      lockScroll();
    }
    function close() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      if (!isAnyOverlayOpen()) unlockScroll();
    }

    function findVariant(product, selectedOptions) {
      // selectedOptions is an array of strings in product.options order.
      for (var i = 0; i < product.variants.length; i++) {
        var v = product.variants[i];
        var match = true;
        for (var j = 0; j < selectedOptions.length; j++) {
          if (v.options[j] !== selectedOptions[j]) { match = false; break; }
        }
        if (match) return v;
      }
      return null;
    }

    function render(product, productUrl) {
      current = product;
      var defaultImage = (product.featured_image || (product.images && product.images[0])) || '';

      // Build a srcset off a Shopify-CDN image URL so the browser picks
      // the right resolution for the panel size on the user's device.
      function buildSrcset(src) {
        if (!src) return '';
        // Strip any existing _xxx.ext sizing token (Shopify CDN convention).
        // We append width with the .ext_{N}x query param style if URL has params,
        // otherwise we use the standard ?width=N param Shopify CDN accepts.
        var base = src.split('?')[0];
        var sizes = [400, 600, 800, 1200, 1600];
        return sizes.map(function (w) {
          return base + '?width=' + w + ' ' + w + 'w';
        }).join(', ');
      }
      function imgTagFor(src, alt) {
        if (!src) return '';
        var srcset = buildSrcset(src);
        return '<img'
          + ' src="' + src + '"'
          + (srcset ? ' srcset="' + srcset + '"' : '')
          + ' sizes="(max-width: 767px) 100vw, (max-width: 1023px) 50vw, 480px"'
          + ' width="800" height="1000"'
          + ' alt="' + escapeHtml(alt || product.title) + '"'
          + ' loading="eager"'
          + ' decoding="async"'
          + '>';
      }

      // Build initial selection = first available variant's options, fallback to first variant
      var initial = product.variants.find(function (v) { return v.available; }) || product.variants[0];
      var selected = initial.options.slice();

      function buildHtml() {
        var variant = findVariant(product, selected) || initial;
        // Use the variant's image if it has one, otherwise the product default.
        var image = (variant && variant.featured_image && variant.featured_image.src) || defaultImage;
        // Prefer server-rendered price strings (from the card's embedded JSON,
        // formatted via Liquid `| money`) so the displayed currency matches
        // the customer's selected Markets currency. Fall back to client-side
        // Intl formatting only when the data wasn't embedded.
        var price = variant.price_formatted || moneyFormat(variant.price);
        var compareFormatted = variant.compare_at_price_formatted ||
          (variant.compare_at_price ? moneyFormat(variant.compare_at_price) : '');
        var compareHtml = '';
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareHtml = '<span class="compare">' + compareFormatted + '</span><span class="sale">' + price + '</span>';
        } else {
          compareHtml = price;
        }

        var html = '';
        html += '<div class="hl-quick-add__media">';
        html += imgTagFor(image);
        html += '</div>';
        html += '<div class="hl-quick-add__info">';
        html += '<h2 class="hl-quick-add__title">' + escapeHtml(product.title) + '</h2>';
        html += '<div class="hl-quick-add__price">' + compareHtml + '</div>';

        // Render each option as a row of buttons.
        // /products/{handle}.js may return options as either an array of strings
        // ("Color", "Size") OR an array of objects ({name, position, values}).
        for (var i = 0; i < product.options.length; i++) {
          var optRaw = product.options[i];
          var optName = (optRaw && typeof optRaw === 'object') ? (optRaw.name || '') : optRaw;
          html += '<div class="hl-quick-add__option" data-option-index="' + i + '">';
          html += '<div class="hl-quick-add__option-label">' + escapeHtml(optName) + ': <strong>' + escapeHtml(selected[i]) + '</strong></div>';
          html += '<div class="hl-quick-add__option-values">';
          // Collect unique values for this option position
          var seen = {};
          product.variants.forEach(function (v) {
            var val = v.options[i];
            if (!val || seen[val]) return;
            seen[val] = true;
            // Determine if any variant with this value (combined with other selected options) is available
            var hypothetical = selected.slice();
            hypothetical[i] = val;
            var hv = findVariant(product, hypothetical);
            var available = hv && hv.available;
            var pressed = val === selected[i];
            html += '<button type="button"';
            html += ' aria-pressed="' + (pressed ? 'true' : 'false') + '"';
            if (!available) html += ' disabled';
            html += ' data-option-set="' + i + '" data-option-value="' + escapeHtml(val) + '">';
            html += escapeHtml(val);
            html += '</button>';
          });
          html += '</div>';
          html += '</div>';
        }

        html += '<div class="hl-quick-add__qty-row">';
        html += '<span class="hl-quick-add__qty-label">Qty</span>';
        html += '<div class="qty hl-quick-add__qty">';
        html += '<button type="button" data-quick-add-qty-dec aria-label="Decrease">&minus;</button>';
        html += '<input type="number" inputmode="numeric" min="1" step="1" data-quick-add-qty value="1" aria-label="Quantity">';
        html += '<button type="button" data-quick-add-qty-inc aria-label="Increase">+</button>';
        html += '</div>';
        html += '</div>';

        html += '<div class="hl-quick-add__cta">';
        html += '<button type="button" data-quick-add-submit data-variant-id="' + variant.id + '"' + (variant.available ? '' : ' disabled') + '>';
        html += variant.available ? 'Add to bag — ' + price : 'Sold out';
        html += '</button>';
        html += '</div>';
        if (productUrl) {
          html += '<a class="hl-quick-add__viewlink" href="' + productUrl + '">View full details &rarr;</a>';
        }
        html += '<div class="hl-quick-add__error" data-quick-add-error hidden></div>';
        html += '</div>';

        body.innerHTML = html;

        // Wire option buttons
        body.querySelectorAll('[data-option-set]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            var idx = parseInt(btn.dataset.optionSet, 10);
            selected[idx] = btn.dataset.optionValue;
            buildHtml();
          });
        });

        // Wire qty stepper — keep the Add to bag button price in sync.
        var qtyInput = body.querySelector('[data-quick-add-qty]');
        var qtyDec = body.querySelector('[data-quick-add-qty-dec]');
        var qtyInc = body.querySelector('[data-quick-add-qty-inc]');
        function refreshSubmitLabel() {
          var btn = body.querySelector('[data-quick-add-submit]');
          if (!btn || !variant.available) return;
          var n = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
          // For qty=1 use the server-formatted unit price (matches Markets
          // currency exactly); for larger qty fall back to client-side
          // Intl formatting in the cart's currency.
          var label = (n === 1 && variant.price_formatted)
            ? variant.price_formatted
            : moneyFormat(variant.price * n);
          btn.textContent = 'Add to bag — ' + label;
        }
        if (qtyDec) qtyDec.addEventListener('click', function () {
          var n = parseInt(qtyInput.value, 10) || 1;
          qtyInput.value = Math.max(1, n - 1);
          refreshSubmitLabel();
        });
        if (qtyInc) qtyInc.addEventListener('click', function () {
          var n = parseInt(qtyInput.value, 10) || 1;
          qtyInput.value = n + 1;
          refreshSubmitLabel();
        });
        if (qtyInput) qtyInput.addEventListener('input', refreshSubmitLabel);

        // Wire submit
        var submitBtn = body.querySelector('[data-quick-add-submit]');
        var errorEl = body.querySelector('[data-quick-add-error]');
        if (submitBtn && variant.available) {
          submitBtn.addEventListener('click', function () {
            errorEl.hidden = true;
            submitBtn.disabled = true;
            submitBtn.textContent = 'Adding…';
            var qty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
            fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({
                items: [{ id: variant.id, quantity: qty }],
                sections: 'cart-drawer,header',
                sections_url: window.location.pathname
              })
            }).then(function (r) {
              if (!r.ok) return r.json().then(function (err) { throw err; });
              return r.json();
            }).then(function (data) {
              submitBtn.textContent = 'Added ✓';
              // Swap the freshly-rendered cart-drawer + header into the DOM
              // BEFORE opening the drawer. The swap happens while the drawer
              // is still closed (off-screen / display:none) so the user never
              // sees stale content flash.
              if (data && data.sections) applySections(data.sections);
              var fresh = getCartDrawer();
              if (fresh) openEl(fresh);
            }).catch(function (err) {
              submitBtn.disabled = false;
              submitBtn.textContent = 'Add to bag — ' + price;
              errorEl.textContent = (err && err.description) || 'Could not add to bag.';
              errorEl.hidden = false;
            });
          });
        }
      }

      buildHtml();
    }

    function escapeHtml(s) {
      return String(s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    document.addEventListener('click', function (e) {
      // Quick-add "direct" mode — POST the variant straight to /cart/add
      // without opening the modal. Used when settings.card_quick_add_action
      // is set to "Add first available variant directly to cart".
      var directBtn = e.target.closest('[data-quick-add-direct]');
      if (directBtn) {
        e.preventDefault();
        e.stopPropagation();
        var variantId = directBtn.dataset.variantId;
        if (!variantId) return;
        var origText = directBtn.innerHTML;
        directBtn.disabled = true;
        directBtn.innerHTML = '<span>Adding…</span>';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({
            items: [{ id: parseInt(variantId, 10), quantity: 1 }],
            sections: 'cart-drawer,header',
            sections_url: window.location.pathname
          })
        }).then(function (r) {
          if (!r.ok) return r.json().then(function (err) { throw err; });
          return r.json();
        }).then(function (data) {
          directBtn.innerHTML = '<span>Added ✓</span>';
          if (data && data.sections) applySections(data.sections);
          var fresh = getCartDrawer();
          if (fresh) openEl(fresh);
          setTimeout(function () { directBtn.innerHTML = origText; directBtn.disabled = false; }, 1500);
        }).catch(function () {
          directBtn.innerHTML = origText;
          directBtn.disabled = false;
        });
        return;
      }

      var trigger = e.target.closest('[data-quick-add]');
      if (trigger) {
        e.preventDefault();
        e.stopPropagation();
        var handle = trigger.dataset.productHandle;
        var url = trigger.dataset.productUrl;
        if (!handle) return;
        body.innerHTML = '<div class="hl-quick-add__loading">Loading…</div>';
        open();

        // Prefer the product JSON embedded in the card by card-product.liquid.
        // Its prices are server-rendered with `{{ ... | money }}`, so they
        // always match the customer's selected Markets currency. The
        // /products/{handle}.js endpoint doesn't reliably honor
        // presentment_currency, so use it only as a fallback.
        var card = trigger.closest('.card');
        var dataEl = card && card.querySelector('script[data-quick-add-product]');
        if (dataEl) {
          try {
            var embedded = JSON.parse(dataEl.textContent);
            render(embedded, url);
            return;
          } catch (err) { /* fall through to fetch */ }
        }

        var currency = (document.body.dataset && document.body.dataset.cartCurrency) || '';
        var productUrlJson = '/products/' + handle + '.js' + (currency ? '?presentment_currency=' + currency : '');
        fetch(productUrlJson, { credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (product) { render(product, url); })
          .catch(function () {
            body.innerHTML = '<div class="hl-quick-add__loading">Could not load product.</div>';
          });
        return;
      }
      if (e.target.closest('[data-quick-add-close]')) {
        e.preventDefault();
        close();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) close();
    });
  })();

  // Legacy quantity steppers — used on the product page (variant qty) and any
  // .qty container that isn't wired up to the new AJAX cart system. We SKIP
  // any input that has [data-line-quantity], because those are handled by the
  // delegated instant-update handler above. Without this skip, clicking +/-
  // on a cart-page line would both update locally AND submit the cart form,
  // causing a full page reload that felt like a "few seconds" delay.
  document.querySelectorAll('.qty').forEach(function (container) {
    var input = container.querySelector('input[type="number"]');
    if (!input) return;
    if (input.hasAttribute('data-line-quantity')) return; // handled by AJAX cart
    var buttons = container.querySelectorAll('button');
    if (buttons.length < 2) return;
    // Also skip if the buttons are wired up to the new cart system already.
    if (buttons[0].hasAttribute('data-cart-qty-decrement')) return;

    var decBtn = buttons[0];
    var incBtn = buttons[buttons.length - 1];

    function step(delta) {
      var current = parseInt(input.value, 10);
      if (isNaN(current)) current = 0;
      var min = parseInt(input.getAttribute('min'), 10);
      if (isNaN(min)) min = 0;
      var next = Math.max(min, current + delta);
      input.value = next;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    decBtn.addEventListener('click', function (e) { e.preventDefault(); step(-1); });
    incBtn.addEventListener('click', function (e) { e.preventDefault(); step(1); });
  });

  // Product variant picker. Each option button carries data-option-position
  // and data-option-value. We track the selected option per position, look
  // up the matching variant in the JSON we render server-side, and update
  // the form's hidden id, the visible price, the Add to bag label, the
  // Klarna line, and the URL ?variant= param. Sold-out variants disable
  // the Add to bag button and hide Buy now.
  document.querySelectorAll('form.hl-product-form').forEach(function (form) {
    var script = form.querySelector('.hl-product-variants');
    if (!script) return;
    var variants;
    try { variants = JSON.parse(script.textContent); } catch (e) { return; }
    if (!variants || !variants.length) return;

    var idInput = form.querySelector('[data-variant-id]');
    var priceEl = form.querySelector('[data-product-price]');
    var addLabel = form.querySelector('[data-add-label]');
    var klarnaEl = form.querySelector('[data-klarna-line]');
    var addBtn = form.querySelector('button[name="add"]');
    var buyNowBtn = form.querySelector('[data-buy-now]');

    var addLabelTemplate = (form.querySelector('section') && form.querySelector('section').dataset && form.querySelector('section').dataset.addLabel) || 'Add to bag';
    // Capture the initial Add to bag prefix (everything before the first em-dash).
    var initialAddText = addLabel ? addLabel.textContent.trim() : 'Add to bag';
    var addPrefix = initialAddText.split('—')[0].trim() || 'Add to bag';
    var soldOutLabel = (addBtn && addBtn.dataset && addBtn.dataset.soldOutLabel) || 'Sold out';
    if (!addBtn) return;

    // Initialize selected[] from active buttons / checked radios / selected dropdowns.
    var selected = [];
    form.querySelectorAll('[data-option-position]').forEach(function (b) {
      var pos = parseInt(b.dataset.optionPosition, 10);
      if (b.tagName === 'SELECT') {
        selected[pos] = b.value;
      } else if (b.tagName === 'INPUT' && b.type === 'radio') {
        if (b.checked) selected[pos] = b.dataset.optionValue;
      } else if (b.classList.contains('swatch-active') || b.classList.contains('size-btn-active') || b.classList.contains('is-active')) {
        selected[pos] = b.dataset.optionValue;
      }
    });

    function findVariant() {
      return variants.find(function (v) {
        return v.options.every(function (opt, i) {
          return selected[i] != null && opt === selected[i];
        });
      });
    }

    function update() {
      var match = findVariant();
      if (!match) return;
      if (idInput) idInput.value = match.id;

      if (priceEl) priceEl.textContent = match.price_formatted;
      if (klarnaEl) {
        var template = klarnaEl.dataset.klarnaTemplate || klarnaEl.textContent;
        var installment = formatMoney(match.price / 4, match.price_formatted);
        klarnaEl.textContent = template.replace('[amount]', installment);
      }

      // Add to bag label
      if (addLabel) {
        if (match.available) {
          addLabel.textContent = addPrefix + ' — ' + match.price_formatted;
        } else {
          addLabel.textContent = soldOutLabel;
        }
      }

      // Sold-out / availability state
      addBtn.disabled = !match.available;
      if (buyNowBtn) buyNowBtn.style.display = match.available ? '' : 'none';

      // URL
      try {
        var url = new URL(window.location);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url);
      } catch (e) { /* ignore in older browsers */ }
    }

    // Format a price (cents) using the same formatting as the server-rendered
    // price (which is the canonical money_without_trailing_zeros string). We
    // can't call the Liquid filter from JS, so we approximate: use the integer
    // form when the original had no decimals, else use 2 decimals.
    function formatMoney(cents, sample) {
      var integerOnly = !/\.\d/.test(sample);
      var amount = cents / 100;
      var str = integerOnly ? Math.round(amount).toString() : amount.toFixed(2);
      // Pull out the leading non-digit from the sample (likely currency symbol).
      var match = sample.match(/^([^\d-]+)/);
      var symbol = match ? match[1] : '';
      return symbol + str;
    }

    function repaintAndUpdate(pos, val) {
      selected[pos] = val;
      form.querySelectorAll('[data-option-position="' + pos + '"]').forEach(function (b) {
        b.classList.remove('swatch-active', 'size-btn-active', 'is-active');
        if (b.tagName === 'SELECT') {
          b.value = val;
        } else if (b.tagName === 'INPUT' && b.type === 'radio') {
          b.checked = (b.dataset.optionValue === val);
          var lbl = b.closest('.hl-variant-radio');
          if (lbl) lbl.classList.toggle('is-active', b.dataset.optionValue === val);
        } else if (b.dataset.optionValue === val) {
          if (b.classList.contains('swatch')) b.classList.add('swatch-active');
          else if (b.classList.contains('size-btn')) b.classList.add('size-btn-active');
          else b.classList.add('is-active');
        }
      });
      var labelEl = form.querySelector('[data-option-label="' + pos + '"]');
      if (labelEl) labelEl.textContent = val;
      update();
    }

    form.querySelectorAll('[data-option-position]').forEach(function (el) {
      var evt = (el.tagName === 'SELECT' || (el.tagName === 'INPUT' && el.type === 'radio')) ? 'change' : 'click';
      el.addEventListener(evt, function (e) {
        if (evt === 'click') e.preventDefault();
        var pos = parseInt(el.dataset.optionPosition, 10);
        var val = el.tagName === 'SELECT' ? el.value : el.dataset.optionValue;
        repaintAndUpdate(pos, val);
      });
    });
  });

  // Buy now: add the current variant to cart, redirect straight to checkout.
  // Lives on the same product form as Add to bag, so we POST the form's
  // FormData to /cart/add.js and on success window.location = /checkout.
  document.querySelectorAll('[data-buy-now]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var form = btn.closest('form');
      if (!form) { window.location.href = '/checkout'; return; }
      var originalLabel = btn.textContent;
      btn.disabled = true;
      btn.querySelector('span').textContent = 'Going to checkout…';
      fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(form),
        headers: { 'Accept': 'application/json' }
      }).then(function (resp) {
        if (resp.ok) { window.location.href = '/checkout'; return; }
        return resp.json().then(function (err) {
          btn.disabled = false;
          btn.querySelector('span').textContent = originalLabel;
          alert(err.description || err.message || 'Could not add to cart.');
        });
      }).catch(function () {
        btn.disabled = false;
        btn.querySelector('span').textContent = originalLabel;
        alert('Network error. Please try again.');
      });
    });
  });

  // Share-block: copy product URL to clipboard.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-share-copy]');
    if (!btn) return;
    e.preventDefault();
    var url = btn.dataset.shareUrl || window.location.href;
    var done = function () {
      var icon = btn.querySelector('i');
      if (!icon) return;
      var prev = icon.className;
      icon.className = 'ti ti-check';
      setTimeout(function () { icon.className = prev; }, 1500);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(done).catch(function () {});
    } else {
      var ta = document.createElement('textarea');
      ta.value = url; document.body.appendChild(ta); ta.select();
      try { document.execCommand('copy'); done(); } catch (e) {}
      document.body.removeChild(ta);
    }
  });
})();
